import {useState} from 'react';
import { Button, Typography } from '@mui/material';
import { isAlphaNumeric, isValidURL } from '../utils/validation';
import { optionsFromList, useOptionSelect } from './optionSelect';
import { useTextEntry } from './textEntry';
export interface PostLoginRestTriggerConfig {
    endpoint: string;
    authType: string;
    secretName: string;
    claims: string[]
}

export const EMPTY_ENDPOINT_OPTIONS: PostLoginRestTriggerConfig = {
    endpoint: "",
    authType: "None",
    secretName: "",
    claims: []
};
const AUTH_OPTIONS = ["Basic", "None"];
export default function useRestTriggerConfig(showError: boolean) {
    const {
        component: endpointEntry,
        value: endpoint,
        setValue: setEndpoint,
        isValid:isEndpointValid
    } = useTextEntry(
        "",
        showError,
        "Rest Endpoint",
        isValidURL
    );

    const {
        component: authSelect,
        selectedOption: authOption,
        setSelection: setAuthOption,
        isOptionSelected: isAuthTypeValid
    } = useOptionSelect(
        "Authentication Type",
        optionsFromList(AUTH_OPTIONS),
        showError
    );
    
    const {
        component: secretNameEntry,
        value: secretName,
        setValue: setSecretName,
        isValid: isSecretNameValid
    } = useTextEntry(
        "",
        showError,
        "Secret Name",
        isAlphaNumeric
    );

    const [claimsList, setClaimsList] = useState<string[]>([]);
    const [showClaimError, setShowClaimError] = useState(false);
    const {
       component: claimEntry,
       value: newClaimName,
       setValue: setNewClaimName,
       isValid: isClaimNameValid
    } = useTextEntry( 
        "", 
        showClaimError,
        "New Claim Name",
        (name: string) => isAlphaNumeric(name) && !claimsList.includes(name)
    );

    const addClaim = () => {
        if (!isClaimNameValid) {
            setShowClaimError(true);
            return;
        } 
        const newClaimList = [...claimsList];
        newClaimList.push(newClaimName);
        setShowClaimError(false);
        setNewClaimName("");
        setClaimsList(newClaimList);
    }
    const removeClaim = (name: string) => {
        const newClaimList = [...claimsList];
        const ind = newClaimList.indexOf(name);
        if (ind < 0) { return; }
        newClaimList.splice(ind, 1);
        setClaimsList(newClaimList);
    }
    const addClaimButton = <Button onClick={addClaim}>Add Claim</Button>

    const claimListComponent = <ul>{
        claimsList.map(
        (claim:string) => <li style={{display:'flex', alignItems:"center", justifyContent:"space-between"}}>
        {claim}
        <Button color="error" onClick={()=>removeClaim(claim)}>Delete</Button>
        </li>
    )}
    </ul>;
    const component = <>
        <div style={{display: "flex", flexDirection:"column"}}>
            {endpointEntry}
            {authSelect}
            {authOption !== "None" && secretNameEntry}
        </div>
        <div style={{display: "flex", flexDirection:"column"}}>
            <Typography variant='h6'>Claims</Typography>
            {claimListComponent}
            {claimEntry}
            {addClaimButton}
        </div>
    </>;
    
    const restConfig: PostLoginRestTriggerConfig = {
        endpoint,
        authType: authOption,
        secretName,
        claims:claimsList
    };
    const setRestConfig = (config: PostLoginRestTriggerConfig) => {
        setEndpoint(config.endpoint);
        setAuthOption(config.authType);
        setSecretName(config.secretName);
        setClaimsList(config.claims);
    }
    const isValid = (isSecretNameValid || authOption === "None")
        && isEndpointValid;
    return {
        component,
        restConfig,
        setRestConfig,
        isValid
    }
}
